// extracted by mini-css-extract-plugin
export default {"reviews":"reviews_reviews__YjNoQ"};